import { AppColor, AppColorContainer } from "./AppColorContainer";

/** This is the color container dark mode implementation used by getAppColorContainer interface implementation. */
export class DarkModeAppColorContainer implements AppColorContainer {
  darkLabelColor: AppColor = { value : "#FAF9F8" };

  mediumLabelColor: AppColor = { value : "#EDEBE9" };

  lightLabelColor: AppColor = { value : "#D2D0CE" };

  timestampLabelColor: AppColor = { value: "#F3F2F1" };

  linkColor: AppColor = { value: "#82ABF1" };

  defaultBackgroundColor: AppColor = { value: "#292827" };

  lightBackgroundColor: AppColor = { value: "#3B3A39" };

  darkBackgroundColor: AppColor = { value: "#161514" };

  primaryWidgetColor: AppColor = { value: "#2552A4" };

  primaryWidgetColorOnHover: AppColor = { value: "#3A70DE" };

  primaryWidgetLabelColor: AppColor = { value: "#ffffff" };

  secondaryWidgetColor: AppColor = { value: "#3B3A39" };

  secondaryWidgetColorOnHover: AppColor = { value: "#1D1C1B" };

  secondaryWidgetLabelColor: AppColor = { value: "#FFFFFF" };

  secondaryWidgetLabelColorOnHover: AppColor = { value: "#598FEC" };

  secondaryWidgetBorderColor: AppColor = { value:  "#797775" };

  blackColor: AppColor = { value: "#ffffff" };

  whiteColor: AppColor = { value: "#292827" };

  wordBlue: AppColor = { value: "#2e6ac5" };

  keyboardFocusColor: AppColor = { value: "#A3A09E" };

  lightBlue: AppColor = { value: "#0078d4" };

  tagBlue: AppColor = { value: "#2E6AC5" };

  bulletGray: AppColor = { value: "#4D4D4D" };

  progressBackground: AppColor = { value: "#545352" };

  popupBackground: AppColor = { value: "#B7D1FF" };

  transcribeIllustrationHeadsetInnerColor: AppColor = { value: "#FEFEFE" };

  transcribeIllustrationHeadsetOuterColor: AppColor = { value: "#DCDCDC" };
}